<template>
  <div>
    <div class="page f-pr">
      <div class="btn-back" @click="goBack">
        <img src="../assets/bar-map/btn-back.png" alt="" />
      </div>
      <img src="../assets/store-bg-1.png" alt="">
      <div class="f-pr">
        <div class="img-row">
          <img src="../assets/store-bg-2.png" alt="">
        </div>
        <!-- <div class="shop-img">
          <img :src="getStoreLogo" alt="" srcset="" />
        </div> -->
        <div class="fcc" @click.stop="showSignPopup()">
          <img src="../assets/btn-stamp.png" alt="" srcset="" class="btn-go" />
        </div>
      </div>

      <div class="page1-content">

        <!-- <div class="fcc">
          <div class="fcc f-pr btn-like" @click.stop="showSignPopup()">
            <img src="../assets/title-dpjj.png" alt="" srcset="" class="title-img" />
            <img src="../assets/btn-msgz.png" alt="" srcset="" class="msgz gif" />
          </div>
        </div> -->
         

        <div class="fcc"> 
          <img :src="getStoreLogo" alt="" srcset="" class="title-img-logo"/>
        </div>

       
        <div style="height:10px;"></div>

        <div class="fcc">
          <img src="../assets/title-dpmc-new.png" alt="" srcset="" class="title-img" />
        </div>
        <div class="article" style="padding: 0;">
          <h2 v-if="storeInfo.nameCh">
            {{ storeInfo.nameCh }}
          </h2>
          <h2 v-if="storeInfo.nameEn">
            {{ storeInfo.nameEn }}
          </h2>
        </div>
        <div class="fcc">
          <img src="../assets/title-yysj-new.png" alt="" srcset="" class="title-img" />
        </div>
        <div class="article">

          <h3 v-if="storeInfo.openTime" v-html="formatOpenTime(storeInfo.openTime)"></h3>
          <h3 v-else>--</h3>
        </div>
        <div class="fcc">
          <img src="../assets/title-dpdz-new.png" alt="" srcset="" class="title-img" />
        </div>
        <div class="article">
          <p>
            {{ storeInfo.addressCh }} <br>{{ storeInfo.addressEn }}
            
          </p>

        </div>
        <div class="fcc">
          <img src="../assets/title-dpjs-new.png" alt="" srcset="" class="title-img" />
        </div>
        <div class="article">
          <p>
            {{ storeInfo.introductionCh }}
          </p>
          <p>
            {{ storeInfo.introductionEn }}
          </p>
        </div>

        <div style="height:60px;"></div>
      </div>








    </div>
    <van-overlay :show="showPopSign" z-index="999" @touchstart="handleTouchStart">
      <div class="fcc-h gz-pop gz-pop-bgimg" style="height: 100vh; overflow: auto">
        <div class="f-pr gz-pop-con fc-h" @click.stop="">


          <input type="text" v-model="inputMoney" @input="handleInput" class="input-money"
            placeholder="請輸入 Please enter">
          <!-- 盖章区域 -->
          <div class="gz-area fcc f-pr">

          </div>

          <div class="x-btn fcc" @click.stop="showPopSign = !showPopSign">
            <img src="../assets/x.png" alt="" srcset="" />
          </div>
        </div>
      </div>
    </van-overlay>


    <van-overlay :show="showSign" z-index="999" :lock-scroll="false" @touchstart="handleTouchStart">
      <div class=" gz-pop fcc-h" style="height: 100vh; overflow: auto">
        <div class="f-pr gb-dk">
          <img src="../assets/gz-dk-new.png" alt="" srcset="" class="gb-dk" />

          <div class="dk-input-area">
            <input
              type="text"
              v-model="checkCode"
              class="dk-input"
              placeholder="請輸入 Please enter"
              @blur="handleCheckCode"
            />
          </div>

          <div class="close-area" @click.stop="showSign = false"></div>
        </div>


      </div>
    </van-overlay>


    <van-overlay :show="showLoading">
      <div class="fcc-h " style="height: 100vh;">
        <van-loading size="24px" vertical color="#fff">Loading...</van-loading>
      </div>
    </van-overlay>

    <div style="
        position: fixed;
        left: 110%;
        top: 110%;
        width: 0;
        height: 0;
        overflow: hidden;
      ">
      <audio id="audioID" ref="audio" class="aud">
        <source src="https://science.warnny.com/fulong/duang.mp3" type="audio/mp3" />
      </audio>
    </div>
  </div>
</template>

<script>
import { getStoreInfo, checkTask, login } from '@/api/api'
import CryptoJS from 'crypto-js'
import { getOrCreateUserId } from '@/utils/auth'
import Harbour from './harbour.vue';

export default {
  data() {
    return {
      showLoading: false,
      showPopSign: false,
      showSign: false,
      storeInfo: {},
      storeId: '',
      checkCode: '',
      inputMoney: '',
      type: 'bar',
      uid: '',
      userInfo: {},
      checking: false,
    }
  },
  computed: {
    getStoreLogo() {
      try {
        return require('../assets/logo-' + this.storeId + '.png')
      } catch (e) {
        return ''
      }
    }
  },
  async mounted() {
    this.storeId = this.$route.params.storeId
    this.type = 'bar'
    if (!this.storeId) {
      this.$router.push('/bar-map')
      return
    }

    const userId = getOrCreateUserId()
    if (userId) {
      this.uid = userId
      this.login(this.uid)
    } else {
      return
    }

    this.getStoreInfo()

    this.$nextTick(() => {
      let Media = document.getElementById("audioID");
      Media.src = "https://science.warnny.com/fulong/duang.mp3";
    });
  },
  methods: {
    goBack() {
      this.$router.push('/bar-map')
    },
    formatOpenTime(time) {
      if (!time) return '--'
      return time.split('\\n').join('<br>')
    },
    login(uid) {
      let self = this
      self.showLoading = true
      login({
        username: uid
      }).then(res => {
        if (res.status != 200) {
          this.$toast(res.msg)
          return
        } else {
          window.localStorage.setItem('uid', res.data.userInfo.username)
          window.localStorage.setItem('token', res.data.token)
          self.uid = res.data.userInfo.username
          self.userInfo = res.data.userInfo
          self.showLoading = false
        }
      })
    },
    async getStoreInfo() {
      this.showLoading = true
      let res = await getStoreInfo(this.storeId)
      this.storeInfo = res.data
      console.log(this.storeInfo)
      this.showLoading = false
    },
    handleInput(e) {
      // 校驗是否為數字包含小數點
      const reg = /^-?(\d+(\.\d*)?|\.\d+)$/;
      if (!reg.test(e.target.value)) {
        this.$toast('請輸入數字\nPlease enter the number')
        this.inputMoney = ''
        return
      }
      this.inputMoney = e.target.value

    },
    async handleTouchStart(event) {

      let that = this;
      if (event.touches.length != 4) {
        return
      }
      if (this.type == 'map') {
        if (!this.inputMoney || this.inputMoney == 0) {
          this.$toast('請輸入消費金額\nPlease enter the purchase\n amount Confirm')
          return
        }
        if (this.inputMoney < 30) {
          this.inputMoney = ''
          this.$toast('消費金額不能低於30\nThe purchase amount \ncannot be less than 30')
          return
        }
      }

      let timestamp = new Date().getTime();
      // 获取触摸点的坐标
      let touchArr = []
      for (let i = 0; i < event.touches.length; i++) {
        var touchX = event.touches[i].clientX;
        var touchY = event.touches[i].clientY;
        let touchItem = [touchX, touchY]
        touchArr.push(touchItem)
      }
      if (this.checking) {
        return
      }
      this.checking = true
      //时间戳
      let request = {
        storeId: that.storeId,
        array: touchArr,
        timestamp: timestamp,
        userId: this.uid,
        type: 'bar',
        amount: this.inputMoney || 0
      }
      let md5Result = CryptoJS.MD5(request.storeId.toString() + request.timestamp.toString() + request.userId.toString()).toString();
      request.sign = md5Result
      request.method = 1
      checkTask(request).then(res => {
        if (res && res.msg) {
          this.$toast(res.msg)
          this.checking = false
        } else if (res) {
          that.showPopSign = false
          that.showSign = false
          that.$toast("打卡成功")
          document.querySelector('audio').play()
          document.getElementById("audioID").play()
          this.checking = false
          setTimeout(() => {
            that.$router.push('/bar-map')
          }, 1500)
        } else {
          if (res.msg) {
            that.$toast("打卡失败，请重试")
            this.checking = false
          }
        }
      })
    },
    handleCheckCode() {
      if (!this.checkCode || this.checkCode.trim() === '') {
        return
      }
      if (this.checking) return
      this.checking = true

      let timestamp = new Date().getTime()
      let request = {
        storeId: this.storeId,
        timestamp: timestamp,
        userId: this.uid,
        type: 'bar',
        command: this.checkCode.trim()
      }
      let md5Result = CryptoJS.MD5(
        request.storeId.toString() + request.timestamp.toString() + request.userId.toString()
      ).toString()
      request.sign = md5Result
      request.method = 2

      checkTask(request).then(res => {
        if (res && res.msg) {
          this.$toast(res.msg)
          this.checking = false
        } else if (res) {
          this.showPopSign = false
          this.showSign = false
          this.$toast('打卡成功')
          document.getElementById('audioID').play()
          this.checking = false
          this.checkCode = ''
          setTimeout(() => {
            this.$router.push('/bar-map')
          }, 1500)
        } else {
          this.$toast('打卡失败，请重试')
          this.checking = false
        }
      }).catch(() => {
        this.$toast('打卡失败，请重试')
        this.checking = false
      })
    },
    showSignPopup() {
      if (this.userInfo.barHoppingActive != 1) {
        this.$toast('請開啟酒吧地圖\nBar hopping is not activated')
        return
      }
      this.inputMoney = ''
      this.showSign = true
    }
  }


}
</script>
<style scoped lang="less">
.btn-back {
  position: absolute;
  left: 26px;
  top: 24px;
  width: 121px;
  z-index: 10;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
  }

  &:active {
    opacity: 0.6;
  }
}

.page {
  display: block;

  min-height: 100vh;
//   background: #fff url(../assets/bg-y.jpg) center 0 repeat-y;
  background: #fff url(../assets/store-bg-3.png) center 0 repeat-y;
  background-size: 100% auto;
  position: relative;

  >img {
    display: block;
    width: 100%;
  }
}

.page1-content {
  background: url(../assets/store-bg-3.png) no-repeat;
  background-size: 100% auto;
  min-height: 50vh;
  padding-top: 20px;
}

.title-img {
  width: 306px;
  display: block;
}

.title-img-logo {
  width: 338px;
  height: auto;
  margin-top: -130px;
  margin-left: 10px;
  display: block;
  z-index: 999;
}

.article {
  width: 75vw;
  margin: 0 auto;
  text-align: center;
  padding: 15px 0;
  font-size: 24px;
  line-height: 44px;

  h3 {
    font-size: 24px;
    margin: 0;
  }

  p {
    margin: 0;
    line-height: 36px;
  }

  p+p {
    margin-top: 1em;
  }
}

.btn-go {
  position: absolute;
  left: 247px;
  bottom: 180px;
  width: 256px;
  img {
    width: 256px;
  }
}

.btn-like {
  img {
    opacity: 0;
  }

  .msgz {
    position: absolute;
    width: 323px;
    left: 0;
    top: 0;
    opacity: 1;
  }
}

.close-area {
  position: absolute;
  right: 20px;
  bottom: 10px;
  width: 138px;
  height: 90px;
  cursor: pointer;

  &:active {
    opacity: 0.5;
  }
}

.x-btn {
  width: 127px;
  height: 127px;
  position: absolute;
  left: -25px;
  top: -38px;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.input-money {
  width: 375px;

  border: 1px solid #00A082;
  text-align: center;
  line-height: 54px;
  background: #fff;
  font-size: 34px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-bottom: 30px;
}

.gz-pop-con {
  width: 630px;
  height: 775px;
  background: url(../assets/gz-pop-img.png) center no-repeat;
  background-size: contain;
  padding-top: 185px;
  box-sizing: border-box;
}

.gif {
  -webkit-animation: gif 1s infinite linear;
  animation: gif 1s infinite linear;
}

.gz-area {
  width: 100%;
  padding-bottom: 70%;
  // background: red;
  opacity: .5;
}

@keyframes gif {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@-webkit-keyframes gif {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.gb-dk {
  width: 700px;
  margin: 0 auto;
  position: relative;
}

.dk-input-area {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100px;
  width: 400px;
  height: 68px;
}

.dk-input {
  width: 100%;
  height: 100%;
  border: 2px solid rgba(100, 180, 160, 0.5);
  border-radius: 8px;
  text-align: center;
  font-size: 28px;
  color: #3d2b1f;
  background: rgba(255, 255, 255, 0.85);
  outline: none;
  padding: 0 16px;
  box-sizing: border-box;

  &::placeholder {
    color: rgba(61, 43, 31, 0.4);
  }
}

.shop-img {
  width: 368px;
  height: auto;
  position: absolute;
  left: 191px;
  top: 78px;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>